import { render, staticRenderFns } from "./ReservationQRCode.vue?vue&type=template&id=60213fe2&scoped=true&"
import script from "./ReservationQRCode.vue?vue&type=script&lang=js&"
export * from "./ReservationQRCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60213fe2",
  null
  
)

export default component.exports